import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GatePass } from 'src/app/_models/gate_pass';
import { AuthService } from 'src/app/_services/auth.service';
import { BillRateItem } from '../../_models/billRateItem';
import { BillingService } from './../../_services/billing.service';

@Component({
  selector: 'app-admin-edit-billing-rate',
  templateUrl: './admin-edit-billing-rate.component.html',
  styleUrls: ['./admin-edit-billing-rate.component.css']
})
export class AdminEditBillingRateComponent implements OnInit {
  billingRateItem: BillRateItem
  billRateForm :FormGroup
  billingChartId=0
  billingCountry=""
  gatePass = new GatePass()
  currency:""
  update_success=false
  constructor(
    private route:ActivatedRoute,
    private router:Router,
    private billingService:BillingService,
    public authService:AuthService
  ) { }
  get f(){
    return this.billRateForm.controls
  }
  ngOnInit(): void {
    this.loadGatePass()
    this.route.params.subscribe(
      x=>{

        let id =+x['id']
        this.billingService.getBillingChartById(id).subscribe(
          x2=>{
            this.billingRateItem=this.mapBillingItem(x2)
            this.billingCountry=x2['countryName']
            this.currency=x2['currency']
            this.billingChartId=id
            this.initForm(this.billingRateItem)
          }
        )
      }
    )

  }
  loadGatePass(){
    this.authService.gatePass.subscribe(
      x=>{this.gatePass=x}
    )
  }
  initForm(billingRateItem:BillRateItem){
    this.billRateForm = new FormGroup({
      'dollar': new FormControl(billingRateItem.dollar, [Validators.required])
    });

  }
  on_submit(){
    this.update_success= false

    let billingRateItem2 = new BillRateItem()
    billingRateItem2.dollar=this.billRateForm.value.dollar

    billingRateItem2.billingChartId=+this.billingChartId

    this.billingService.update(billingRateItem2).subscribe(
      x=>{
        this.billingRateItem=this.mapBillingItem(x)
        this.update_success=true
        this.router.navigate(['/admin/billing/index'])
      }
    )

  }
  mapBillingItem(x){
    let b = new BillRateItem()
    b.week = x['baseWeek']
    b.month = x['baseMonth']
    b.year = x['baseYear']
    b.dollar = x['dollar']
    b.billingChartId = x['id']
    return b
  }

}
